import { __PopularCoinCardProps } from './popularCoinCard.interface';
import CoinIcon from 'utilities/components/coinIcon/coinIcon.index';
import { IoIosArrowBack } from 'react-icons/io';
import { ReactComponent as ArrowIcon } from 'assets/icons/convertBox/Arrow.svg';
import { priceDigit } from 'scripts';

export const MostPopularCoinCard = (props: __PopularCoinCardProps) => {
    return (
        <div
            onClick={() => props.selectCoin(props.coin)}
            className="flex items-center gap-3 p-4 flex-1 rounded-lg border border-primary-20 hover:bg-primary-5 cursor-pointer group"
        >
            <div className="flex flex-col gap-2 flex-1">
                <div className="flex items-center gap-3">
                    <CoinIcon className="w-8 h-8 cursor-pointer" symbol={props.coin.symbol} />
                    <label className="font-bold text-base text-darkPurple-100 cursor-pointer">{props.coin.name}</label>
                    <label className="text-sm font-medium text-darkPurple-100 en cursor-auto">
                        {props.coin.symbol}
                    </label>
                    <div className="flex items-center gap-1">
                        <label
                            className={`flex items-center gap-[2px] text-sm font-medium ${props.coin.changeOf24HourPercent === 0 ? 'text-darkPurple-100' : props.coin.changeOf24HourPercent > 0 ? 'text-positive-dark' : 'text-negative-dark'}`}
                        >
                            <p className="cursor-pointer">{props.coin.changeOf24HourPercent !== 0 && '٪'}</p>
                            <p className="cursor-pointer" style={{ direction: 'ltr' }}>
                                {props.coin.changeOf24HourPercent !== 0 ? props.coin.changeOf24HourPercent : '-'}
                            </p>
                        </label>
                        {props.coin.changeOf24HourPercent !== 0 && (
                            <ArrowIcon
                                className={`w-4 h-4 ${props.coin.changeOf24HourPercent > 0 ? 'text-positive-dark' : 'text-negative-dark'} ${props.coin.changeOf24HourPercent > 0 ? 'rotate-180' : ''}`}
                            />
                        )}
                    </div>
                </div>
                <div className="flex items-center gap-1">
                    <label className="text-sm font-medium text-darkPurple-100">آخرین قیمت:</label>
                    <label className="text-sm font-bold text-darkPurple-100">
                        { priceDigit(props.coin.sellPrice)} تومان
                    </label>
                </div>
            </div>
            <div className="w-6 h-6 flex items-center justify-center bg-background text-primary-100 group-hover:bg-primary-100 group-hover:text-white rounded-full transition-all cursor-pointer duration-300">
                <IoIosArrowBack />
            </div>
        </div>
    );
};
